import {
  getFirstAttackAsStep,
  getScenarioStepCount
} from 'components/scenarios/utils'
import useAgent from 'hooks/use-agent'
import useAuth from 'hooks/use-auth'
import { Scenario, TargetDefinition } from 'types/api/scenarios/scenario'

export type ScheduledScenarioDetails = {
  name: string
  commandType: string
  stepCount: number
  targetParams: Record<string, any>
  additionalTargetParamsAmount: number
  firstTargetParam: [string, any]
  targetDefinition: TargetDefinition
}

export interface ScheduledScenarioResults {
  isLoading: boolean
  hasError: boolean
  scenarioDetails?: ScheduledScenarioDetails
}

export default function useScenarioScheduleDetails(
  scenarioId
): ScheduledScenarioResults {
  const { currentTeamId } = useAuth()
  const {
    data: scenario,
    isLoading,
    hasError
  } = useAgent<Scenario>(
    `/scenarios/${scenarioId}?teamId=${currentTeamId}`,
    {} as Scenario,
    { shouldCache: true }
  )

  if (isLoading || hasError) {
    return { isLoading, hasError, scenarioDetails: null }
  }

  const { impactDefinition = {}, targetDefinition } =
    getFirstAttackAsStep(scenario) ?? {}

  const targetParams = Object.assign(
    targetDefinition?.strategy?.tags ?? {},
    targetDefinition?.strategy?.multiSelectTags ?? {},
    targetDefinition?.strategy?.labels ?? {},
    targetDefinition?.strategy?.multiSelectLabels ?? {}
  )
  const targetParamsList = Object.entries(targetParams)

  return {
    scenarioDetails: {
      name: scenario.name,
      commandType: impactDefinition.commandType,
      stepCount: getScenarioStepCount(scenario),
      targetParams,
      additionalTargetParamsAmount:
        targetParamsList.length > 1 ? targetParamsList.length - 1 : null,
      firstTargetParam: targetParamsList[0],
      targetDefinition
    },
    isLoading,
    hasError
  }
}
